export function Footer(): JSX.Element {
  return (
    <div id="footer">
      {" "}
      <a className="links" href="https://github.com/keadeish">
        GitHub{" "}
      </a>
      |{" "}
      <a className="links" href="https://twitter.com/psychician">
        Twitter
      </a>{" "}
      |{" "}
      <a className="links" href="https://www.instagram.com/keadeish/">
        Instagram
      </a>{" "}
      |{" "}
      <a className="links" href="https://myanimelist.net/profile/Jump_Reaper">
        MAL
      </a>
    </div>
  );
}
